/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React, { useState } from "react";
import {useAuth0} from "@auth0/auth0-react";
import {
    PageHeader
} from "grommet/components/PageHeader";
import {
    Box,
    Grid,
    Form,
    FormField,
    TextInput,
    Heading,
    Page,
    PageContent,
    Button
} from "grommet";
import {
    getUser,
} from "API/API";
import SendMessage from "Components/Messaging/SendMessage";



type Props = {}

const Messages: React.FC<Props> = (props) => {


    return (
        <Page kind={"wide"}>
            <PageHeader
                title={"My Messages"}
                subtitle={""}
                margin={"medium"}
                actions={ <SendMessage buttonText={"New Message"} />}
            />

            <PageContent>
                <Grid
                    rows={['medium', 'medium']}
                    columns={['small', 'large']}
                    gap="small"
                    areas={[
                        { name: 'Conversations', start: [0, 0], end: [0, 0] },
                        { name: 'Messages', start: [1, 0], end: [1, 0] },
                    ]}
                >
                    <Box gridArea={"Conversations"}>

                    </Box>
                </Grid>
            </PageContent>
        </Page>
    )
}

export default Messages
